import { createContext } from '@lit/context';
export { ContextConsumer, ContextProvider } from '@lit/context';

export const moduleKey = Symbol('moduleKey');
export const moduleContext = createContext(moduleKey);

export const workflowKey = Symbol('workflowKey');
export const workflowContext = createContext(workflowKey);
